"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var inStorePaymentFormErrorTransformer_1 = require("../service/inStorePaymentFormErrorTransformer");
var flattenFormData = function (formData) {
    if (!formData) {
        return {};
    }
    return Object.entries(formData).reduce(function (prevValue, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        return (__assign(__assign({}, prevValue), (typeof value === 'object'
            ? __assign({}, flattenFormData(value)) : (_b = {},
            _b[key] = value,
            _b))));
    }, {});
};
var useInStorePaymentFormValidate = function () {
    var intl = react_intl_1.useIntl();
    var _a = react_1.useState(true), hasErrors = _a[0], setHasErrors = _a[1];
    var _b = react_1.useState(null), asyncErrors = _b[0], setAsyncErrors = _b[1];
    var checkEmptyFields = function (requiredFields, formData) {
        var flattenedFormData = flattenFormData(formData);
        return requiredFields.some(function (requiredField) { return !flattenedFormData[requiredField]; });
    };
    var handleValidationErrors = react_1.useCallback(function (requiredFields, data) {
        var _a;
        var hasValidationErrors = ((_a = data.errors) === null || _a === void 0 ? void 0 : _a.length) > 0;
        setHasErrors(checkEmptyFields(requiredFields, data.formData) || hasValidationErrors);
    }, [hasErrors, asyncErrors]);
    var handleAsyncValidationErrors = react_1.useCallback(function (errors) {
        var err = inStorePaymentFormErrorTransformer_1.default.from(errors, intl);
        setAsyncErrors(err);
    }, [intl]);
    var resetAsyncErrors = react_1.useCallback(function () {
        setAsyncErrors(null);
    }, []);
    return { handleValidationErrors: handleValidationErrors, hasErrors: hasErrors, asyncErrors: asyncErrors, handleAsyncValidationErrors: handleAsyncValidationErrors, resetAsyncErrors: resetAsyncErrors };
};
exports.default = useInStorePaymentFormValidate;
